import {planTypes} from "@/common/constants";

export default {
  key: planTypes[planTypes.ZOOM_PHONE$ZPI],
  data() {
    return {
      title: this.$t('billing.pbx.plan_name.ZPI'),
      subtitle: '',
      planType: planTypes.ZOOM_PHONE$ZPI,
      description: this.$t('billing.pbx.plan_desc.ZPI'),
    }
  }
};
